import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router'
import AppErrorBoundary from './components/AppErrorBoundary'
import Header from './components/Header'
import Footer from './components/Footer'
import RequireAuth from './components/RequireAuth'
import { AuthProvider } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { WatchlistProvider } from './contexts/WatchlistContext'
import { ToastProvider } from './contexts/ToastContext'
import AccountLayout from './components/account/AccountLayout'
import AccountNotificationsSection from './components/account/AccountNotificationsSection'
import NotificationsInbox from './components/notifications/NotificationsInbox'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import SearchPage from './pages/SearchPage'
import FindConnectionPage from './pages/FindConnectionPage'
import CompanyProfilePage from './pages/CompanyProfilePage'
import PersonDetailPage from './pages/PersonDetailPage'
import WatchlistRedirect from './pages/WatchlistRedirect'
import WatchlistPage from './pages/WatchlistPage'
import NotificationsPage from './pages/NotificationsPage'
import AccountOverviewPage from './pages/account/AccountOverviewPage'
import AccountSettingsPage from './pages/account/AccountSettingsPage'
import AccountNotificationsPage from './pages/account/AccountNotificationsPage'
import AccountAdminPage from './pages/account/AccountAdminPage'
import AdminUserProfilePage from './pages/account/AdminUserProfilePage'
import AdminUserWatchlistListPage from './pages/account/AdminUserWatchlistListPage'
import InvitePage from './pages/InvitePage'

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
      <WatchlistProvider>
      <ToastProvider>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Header />
            <AppErrorBoundary>
              <main className="flex-1">
                <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/invite" element={<InvitePage />} />
              <Route
                path="/"
                element={
                  <RequireAuth>
                    <HomePage />
                  </RequireAuth>
                }
              />
              <Route
                path="/search"
                element={
                  <RequireAuth>
                    <SearchPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/company/:cvrNumber"
                element={
                  <RequireAuth>
                    <CompanyProfilePage />
                  </RequireAuth>
                }
              />
              <Route
                path="/person/:enhedsNummer"
                element={
                  <RequireAuth>
                    <PersonDetailPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/forbindelse"
                element={
                  <RequireAuth>
                    <FindConnectionPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/watchlist"
                element={
                  <RequireAuth>
                    <WatchlistRedirect />
                  </RequireAuth>
                }
              />
              <Route
                path="/notifications"
                element={
                  <RequireAuth>
                    <NotificationsPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/account"
                element={
                  <RequireAuth>
                    <AccountLayout />
                  </RequireAuth>
                }
              >
                <Route index element={<AccountOverviewPage />} />
                <Route path="indstillinger" element={<AccountSettingsPage />} />
                <Route path="watchlist" element={<WatchlistPage />} />
                <Route path="notifikationer" element={<AccountNotificationsPage />}>
                  <Route index element={<Navigate to="indbakke" replace />} />
                  <Route path="indbakke" element={<NotificationsInbox embedded />} />
                  <Route
                    path="indstillinger"
                    element={<AccountNotificationsSection embedded />}
                  />
                </Route>
                <Route path="admin" element={<AccountAdminPage />} />
                <Route path="admin/brugere/:userId" element={<AdminUserProfilePage />} />
                <Route
                  path="admin/brugere/:userId/watchlist/uncategorized"
                  element={<AdminUserWatchlistListPage />}
                />
                <Route
                  path="admin/brugere/:userId/watchlist/lister/:listId"
                  element={<AdminUserWatchlistListPage />}
                />
              </Route>
                </Routes>
              </main>
            </AppErrorBoundary>
            <Footer />
          </div>
        </Router>
      </ToastProvider>
      </WatchlistProvider>
      </NotificationProvider>
    </AuthProvider>
  )
}

export default App
